var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-body" }, [
    _c("div", {}, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c("h5", { staticClass: "card-title" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("p", {
            staticClass: "card-text",
            domProps: { innerHTML: _vm._s(_vm.description) }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-4" },
          [
            _c("transition", { attrs: { name: "fade" } }, [
              _vm.changed_data_set
                ? _c(
                    "div",
                    {
                      staticClass:
                        " d-flex justify-content-end align-items-center "
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn btn-secondary",
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("save")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", {}, [
      _c(
        "ul",
        { staticClass: "list-group list-group-flush" },
        _vm._l(_vm.selected_modules, function(module, index) {
          return _c(
            "li",
            {
              staticClass: "list-group-item",
              class: {
                "bg-secondary text-white":
                  _vm.isActive(module, index) && index !== "category_list",
                "cursor-pointer": index !== "category_list"
              },
              on: {
                click: function($event) {
                  _vm.setActive(module, index)
                }
              }
            },
            [
              _c("div", { staticClass: "text-capitalize" }, [
                _vm._v(_vm._s(module.title))
              ]),
              _vm._v(" "),
              _vm.hasOwnNestedProperty(module, "params.filter") &&
              module.params.filter != null
                ? _c("div", { staticClass: "w-100" }, [
                    module.params.filter == "category"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(_vm.categories, function(category) {
                            return _c(
                              "div",
                              { staticClass: "col form-check" },
                              [
                                _c("input", {
                                  staticClass: "form-check-input",
                                  class: index,
                                  attrs: {
                                    type: "checkbox",
                                    name:
                                      _vm.module_set +
                                      "->modules->" +
                                      index +
                                      "->selects->" +
                                      category.id,
                                    id: index + "--" + category.slug
                                  },
                                  domProps: {
                                    checked: _vm.isCategorySelected(
                                      category,
                                      index
                                    )
                                      ? true
                                      : false
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.categorySelected(category, index)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "form-check-label",
                                    attrs: { for: index + "--" + category.slug }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.lang(
                                            "title",
                                            category.category_data.lang
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          })
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a5ac308", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a5ac308","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/modules/PagesManager.vue
// module id = 743
// module chunks = 0